"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ConfirmEmailCheckboxComponent = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _material = require("@mui/material");

var ConfirmEmailCheckboxComponent = function ConfirmEmailCheckboxComponent(_ref) {
  var value = _ref.value,
      name = _ref.name,
      onChange = _ref.onChange;
  return /*#__PURE__*/_react.default.createElement(_material.Box, {
    border: 1,
    borderRadius: "5px",
    borderColor: "green.fruitSalad",
    mt: 3,
    pb: 1,
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    bgcolor: "green.fruitSaladLight"
  }, /*#__PURE__*/_react.default.createElement(_material.Checkbox, {
    checked: value,
    color: "primary",
    onChange: onChange,
    value: "gilad"
  }), /*#__PURE__*/_react.default.createElement(_material.Box, {
    mt: 1,
    className: "Body-Regular-Left-Success"
  }, "I have checked my personalized note to ", name, " and confirm that it looks good."));
};

exports.ConfirmEmailCheckboxComponent = ConfirmEmailCheckboxComponent;
ConfirmEmailCheckboxComponent.propTypes = {
  value: _propTypes.default.bool.isRequired,
  name: _propTypes.default.string.isRequired,
  onChange: _propTypes.default.func.isRequired
};
var _default = ConfirmEmailCheckboxComponent;
exports.default = _default;